import Joi, { CustomHelpers } from 'joi';
import _isString from 'lodash/isString';
import { TFunction } from 'i18next';

/**
 * Validates an email with specific allowed TLDs (.com/.net)
 */

export const emailSchema = (t: TFunction) =>
  Joi.string()
    .custom((value: string, helpers: CustomHelpers) => {
      // istanbul ignore next
      if (!_isString(value)) return helpers.error('any.invalid');

      if (value.length > 254) return helpers.error('string.max');

      const parts = value.split('@');
      if (parts.length !== 2) return helpers.error('string.email');

      const localPart = parts[0];
      if (localPart.length > 64) return helpers.error('string.emailLocalPartLengthExceeded');

      const domain = parts[1];
      if (!domain) return helpers.error('any.invalid');

      const labels = domain.toLowerCase().split('.');
      if (labels.length < 2) return helpers.error('any.invalid');

      const finalLabel = labels[labels.length - 1];
      if (!finalLabel) return helpers.error('any.invalid');

      return value;
    })
    .messages({
      'string.empty': t('login:signUp.emailAddressRequiredMessage'),
      'string.email': t('login:signUp.invalidEmailFormatMessage'),
      'string.max': t('login:signUp.emailTotalLengthExceeded'),
      'string.emailLocalPartLengthExceeded': t('login:signUp.emailLocalPartLengthExceeded'),
      'any.invalid': t('login:signUp.invalidEmailFormatMessage'),
      'string.invalidRootTld': t('login:signUp.invalidEmailTldMessage'),
    });
